const defaultLocation = 'London';

const map: { [key: string]: string } = {
    AE: 'Dubai'
};

export default (geoIpCountry: string): string =>
    geoIpCountry in map ? map[geoIpCountry] : defaultLocation;
